import React from 'react';
import { m } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
import { CHECKOUT_URL } from '../../utils/checkout';
import { pricingRows, pricingTrustItems } from '../../data/pricing';
export function Pricing() {
  return <section id="oferta-base" className="bg-white py-10 sm:py-14" data-id="element-176" data-mp="3gijjanzpi1ed">
      <div className="mx-auto max-w-2xl px-4 text-center sm:px-6" data-id="element-177" data-mp="3gkw91nbphg1z">
        <SectionTag icon="💰" data-id="element-178" data-mp="3lh4j4mb1qj2a">Oferta Especial</SectionTag>
        <h2 className="mt-4 font-heading text-3xl font-bold uppercase leading-tight text-azul sm:text-4xl" data-id="element-179" data-mp="3pj7wxhl6tzqq">
          ¿Cuánto vale para ti recuperar tus domingos?
        </h2>
        <p className="mt-3 text-base text-muted sm:text-lg" data-id="element-180" data-mp="3ugrkj83rzovc">
          Acceso inmediato y garantía total de 14 días.
        </p>
      </div>

      <div className="mx-auto mt-8 max-w-md px-4 sm:px-6" data-id="element-181" data-mp="205cueq6urnf2">
        <m.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.45
      }} className="rounded-3xl border-2 border-naranja bg-bg-secondary p-6 shadow-card sm:p-7" data-id="element-182" data-mp="206wcmmc2k8jh">
          <p className="font-heading text-xs font-semibold uppercase tracking-wider text-muted" data-id="element-183" data-mp="16hx8f3ct0ktf">
            🏐 VOLEY-PRO 360: La Pizarra del Entrenador
          </p>
          <p className="mt-1.5 text-xs text-muted" data-id="element-184" data-mp="xkmx5hzzkvoi">6 tomos + 5 bonos, listos para llevar a la pista.</p>

          <div className="mt-4 space-y-1.5" data-id="element-185" data-mp="1u8b6bai2ldvx">
            {pricingRows.map(row => <div key={row.content} className="flex items-center justify-between gap-3 border-b border-gris-claro py-1.5 text-sm" data-id="element-186" data-mp="1pbkpgkyfye9g">
                <span className="text-gris-oscuro" data-id="element-187" data-mp="1gacry53r1hgf">{row.content}</span>
                <span className="flex flex-shrink-0 items-center gap-2" data-id="element-188" data-mp="1gc623udkmjt6">
                  {row.value !== '∞' && <span className="text-muted" data-id="element-189" data-mp="9reknzye1c0i">{row.value}</span>}
                  {row.value === '∞' && <span className="text-muted" data-id="element-190" data-mp="4wr5irp9xtyl">{row.value}</span>}
                  <CheckIcon size={14} className="text-success" data-id="element-191" data-mp="6d4xjk9hz12l" />
                </span>
              </div>)}
            <div className="flex items-center justify-between py-1.5 text-sm font-semibold text-azul-dark" data-id="element-192" data-mp="ba51npmsdtr2">
              <span data-id="element-193" data-mp="3tim1pxj37cow">VALOR TOTAL</span>
              <span className="text-rojo line-through" data-id="element-194" data-mp="1c7ez6kks50k">119,40€</span>
            </div>
          </div>

          <p className="mt-4 text-xs font-medium text-muted" data-id="element-195" data-mp="3jq7yf0cd1y0m">Precio hoy (85% de descuento):</p>
          <p className="font-heading text-5xl font-bold text-azul sm:text-6xl" data-id="element-196" data-mp="3ohyezo1w5i0h">17,99€</p>
          <span className="mt-2 inline-block rounded-full bg-naranja-light px-3 py-1 text-sm font-semibold text-amarillo" data-id="element-197" data-mp="39stug07mj1p7">
            ⏰ Precio de lanzamiento — sube pronto
          </span>

          <div className="mt-6" data-id="element-198" data-mp="30rvnb91w2e2e">
            <a href={CHECKOUT_URL} className="group flex w-full items-center justify-center gap-2 rounded-xl border-2 border-naranja bg-gradient-to-br from-azul to-azul-dark px-8 py-4 font-heading text-base font-semibold uppercase tracking-wide text-white shadow-card transition-[filter] duration-200 hover:brightness-90 active:scale-[0.98] focus:outline-none focus-visible:ring-2 focus-visible:ring-azul focus-visible:ring-offset-2 focus-visible:ring-offset-white sm:text-lg" data-id="element-199" data-mp="30rm01t88al0e">
              Quiero Voley-Pro 360 por 17,99€
            </a>
          </div>

          <div className="mt-4 flex flex-wrap justify-center gap-x-4 gap-y-1 text-[11px] text-muted" data-id="element-200" data-mp="35399pd4w1hpl">
            {pricingTrustItems.map(item => <span key={item.label} className="flex items-center gap-1" data-id="element-201" data-mp="3033q8k8rv1il">
                <item.icon size={12} data-id="element-202" data-mp="3etb1aewg9i99" /> {item.label}
              </span>)}
          </div>
        </m.div>
      </div>
    </section>;
}